<div class="modal-header" *ngIf="title || dismissible">
  <h5 class="modal-title">{{ title }}</h5>
  <button *ngIf="dismissible" type="button" class="btn-close" aria-label="Close" (click)="closed.emit()"></button>
</div>
<div class="modal-body"><ng-content></ng-content></div>
<div class="modal-footer"><ng-content select="[bk-modal-footer]"></ng-content></div>
